
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 10a2 2 0 012 2v4a2 2 0 01-2 2H2a2 2 0 01-2-2v-4a2 2 0 012-2zm10 0a2 2 0 012 2v4a2 2 0 01-2 2h-4a2 2 0 01-2-2v-4a2 2 0 012-2zM6 12H2v4h4zm10 0h-4v4h4zM6 0a2 2 0 012 2v4a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm10 0a2 2 0 012 2v4a2 2 0 01-2 2h-4a2 2 0 01-2-2V2a2 2 0 012-2zM6 2H2v4h4zm10 0h-4v4h4z","fill-rule":"evenodd"}})])
          )
        }
      }
    